import {FiEnvironment} from "./env";

export const environment: FiEnvironment = {
    production: false,
    backend: '/backend',
};
